module.exports = __webpack_public_path__ + "img/dollar.52ab0e52.svg";